import { PaymentDetails } from '../components/methods/payment-methods.models';

import { PaymentMethod, PaymentModeInfo, SelectedDiscount } from '@features/payment';

export interface PaymentState {
    methods: PaymentMethodsState;
    filteredMethods: PaymentMethodsState;
    selectedPaymentMethod: any;
    selectedPaymentMethodFinal: any;
    paymentDetails: PaymentDetails;
    paymentModeInfo: PaymentModeInfo;
    selectedDiscount: SelectedDiscount[];
    bank?: string;
    isRepay: boolean;
    paymentReady: boolean;
    loaded: boolean;
    loading: boolean;
}

export interface PaymentMethodsState {
    values: PaymentMethod[];
    status: 'errored' | 'loaded' | 'loading' | undefined;
}

export const paymentInitialState: PaymentState = {
    methods: {
        values: [],
        status: null,
    },
    filteredMethods: {
        values: [],
        status: null,
    },
    paymentModeInfo: {
        governmentIdMandatory: false,
        isEmployee: false,
        paymentModes: [],
        personalizationId: null,
        rueiData: null,
    },
    selectedPaymentMethod: null,
    selectedPaymentMethodFinal: null,
    bank: null,
    paymentDetails: {
        valid: false,
        saveCard: false,
        values: null,
    },
    selectedDiscount: [],
    paymentReady: false,
    isRepay: false,
    loaded: true,
    loading: false,
};
